import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from './CoroutineDispatcher.mjs';
import { invokeOnCancellationb68niwbjdmgy as invokeOnCancellation } from './CancellableContinuation.mjs';
import { Delay9umexudtwyie as Delay } from './Delay.mjs';
import { ArrayDeque2dzc9uld4xi7n as ArrayDeque } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayDeque.mjs';
import { removeFirstOrNull15yg2tczrh8a7 as removeFirstOrNull } from '../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Runnablezd7bpy5et5p0 as Runnable } from './Runnable.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { coerceIn302bduskdb54x as coerceIn } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { boxApply1qmzdb3dh90hg as boxApply } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CancelHandler3ic7xysezxbm5 as CancelHandler } from './CancellableContinuationImpl.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NodeDispatcherClass;
function NodeDispatcher() {
  if (NodeDispatcherClass === VOID) {
    class $ extends SetTimeoutBasedDispatcher() {
      constructor() {
        NodeDispatcher_instance = null;
        super();
        NodeDispatcher_instance = this;
      }
      daf() {
        process.nextTick(this.kaf_1.iaf_1);
      }
    }
    initMetadataForObject($, 'NodeDispatcher', VOID, VOID, VOID, [1]);
    NodeDispatcherClass = $;
  }
  return NodeDispatcherClass;
}
var NodeDispatcher_instance;
function NodeDispatcher_getInstance() {
  if (NodeDispatcher_instance === VOID)
    new (NodeDispatcher())();
  return NodeDispatcher_instance;
}
var ScheduledMessageQueueClass;
function ScheduledMessageQueue() {
  if (ScheduledMessageQueueClass === VOID) {
    class $ extends MessageQueue() {
      constructor(dispatcher) {
        super();
        this.haf_1 = dispatcher;
        var tmp = this;
        tmp.iaf_1 = () => {
          this.oaf();
          return Unit_instance;
        };
      }
      paf() {
        this.haf_1.daf();
      }
      qaf() {
        setTimeout(this.iaf_1, 0);
      }
      raf(timeout) {
        setTimeout(this.iaf_1, timeout);
      }
    }
    initMetadataForClass($, 'ScheduledMessageQueue');
    ScheduledMessageQueueClass = $;
  }
  return ScheduledMessageQueueClass;
}
function w3cSetTimeout(handler, timeout) {
  return setTimeout(handler, timeout);
}
var WindowMessageQueueClass;
function WindowMessageQueue() {
  if (WindowMessageQueueClass === VOID) {
    class $ extends MessageQueue() {
      constructor(window_0) {
        super();
        this.gag_1 = window_0;
        this.hag_1 = 'dispatchCoroutine';
        this.gag_1.addEventListener('message', (event) => {
          var tmp;
          if (event.source == this.gag_1 && event.data == this.hag_1) {
            event.stopPropagation();
            this.oaf();
            tmp = Unit_instance;
          }
          return Unit_instance;
        }, true);
      }
      paf() {
        var tmp = Promise.resolve(Unit_instance);
        tmp.then((it) => {
          this.oaf();
          return Unit_instance;
        });
      }
      qaf() {
        this.gag_1.postMessage(this.hag_1, '*');
      }
    }
    initMetadataForClass($, 'WindowMessageQueue');
    WindowMessageQueueClass = $;
  }
  return WindowMessageQueueClass;
}
function w3cSetTimeout_0(window_0, handler, timeout) {
  return setTimeout_0(window_0, handler, timeout);
}
function w3cClearTimeout(window_0, handle) {
  return window_0.clearTimeout(handle);
}
function w3cClearTimeout_0(handle) {
  return clearTimeout(handle);
}
function setTimeout_0(window_0, handler, timeout) {
  return window_0.setTimeout(handler, timeout);
}
var SetTimeoutDispatcherClass;
function SetTimeoutDispatcher() {
  if (SetTimeoutDispatcherClass === VOID) {
    class $ extends SetTimeoutBasedDispatcher() {
      constructor() {
        SetTimeoutDispatcher_instance = null;
        super();
        SetTimeoutDispatcher_instance = this;
      }
      daf() {
        this.kaf_1.raf(0);
      }
    }
    initMetadataForObject($, 'SetTimeoutDispatcher', VOID, VOID, VOID, [1]);
    SetTimeoutDispatcherClass = $;
  }
  return SetTimeoutDispatcherClass;
}
var SetTimeoutDispatcher_instance;
function SetTimeoutDispatcher_getInstance() {
  if (SetTimeoutDispatcher_instance === VOID)
    new (SetTimeoutDispatcher())();
  return SetTimeoutDispatcher_instance;
}
var SetTimeoutBasedDispatcherClass;
function SetTimeoutBasedDispatcher() {
  if (SetTimeoutBasedDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor() {
        super();
        this.kaf_1 = new (ScheduledMessageQueue())(this);
      }
      ra8(context, block) {
        this.kaf_1.saf(block);
      }
      za8(timeMillis, block, context) {
        var handle = w3cSetTimeout(() => {
          block.ca8();
          return Unit_instance;
        }, delayToInt(timeMillis));
        return new (ClearTimeout())(handle);
      }
      ya8(timeMillis, continuation) {
        var handle = w3cSetTimeout(() => {
          // Inline function 'kotlin.with' call
          continuation.za7(this, Unit_instance);
          return Unit_instance;
        }, delayToInt(timeMillis));
        invokeOnCancellation(continuation, new (ClearTimeout())(handle));
      }
    }
    initMetadataForClass($, 'SetTimeoutBasedDispatcher', VOID, VOID, [CoroutineDispatcher(), Delay()], [1]);
    SetTimeoutBasedDispatcherClass = $;
  }
  return SetTimeoutBasedDispatcherClass;
}
var MessageQueueClass;
function MessageQueue() {
  if (MessageQueueClass === VOID) {
    class $ {
      constructor() {
        this.laf_1 = ArrayDeque().xk();
        this.maf_1 = 16;
        this.naf_1 = false;
      }
      saf(element) {
        this.taf(element);
        if (!this.naf_1) {
          this.naf_1 = true;
          this.paf();
        }
      }
      oaf() {
        try {
          // Inline function 'kotlin.repeat' call
          var times = this.maf_1;
          var inductionVariable = 0;
          if (inductionVariable < times)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp0_elvis_lhs = removeFirstOrNull(this);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                return Unit_instance;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var element = tmp;
              element.ca8();
            }
             while (inductionVariable < times);
        }finally {
          if (this.i1()) {
            this.naf_1 = false;
          } else {
            this.qaf();
          }
        }
      }
      taf(element) {
        return this.laf_1.v(element);
      }
      v(element) {
        return this.taf((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      uaf(index, element) {
        this.laf_1.y3(index, element);
      }
      y3(index, element) {
        return this.uaf(index, (!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      vaf(element) {
        return this.laf_1.w3(element);
      }
      w3(element) {
        if (!(!(element == null) ? isInterface(element, Runnable()) : false))
          return false;
        return this.vaf((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      waf(elements) {
        return this.laf_1.r1(elements);
      }
      r1(elements) {
        return this.waf(elements);
      }
      xaf(elements) {
        return this.laf_1.w2(elements);
      }
      w2(elements) {
        return this.xaf(elements);
      }
      yaf(elements) {
        return this.laf_1.x3(elements);
      }
      x3(elements) {
        return this.yaf(elements);
      }
      v3() {
        this.laf_1.v3();
      }
      zaf(index, element) {
        return this.laf_1.b2(index, element);
      }
      b2(index, element) {
        return this.zaf(index, (!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      z3(index) {
        return this.laf_1.z3(index);
      }
      u1(index) {
        return this.laf_1.u1(index);
      }
      m3(fromIndex, toIndex) {
        return this.laf_1.m3(fromIndex, toIndex);
      }
      i1() {
        return this.laf_1.i1();
      }
      aag(element) {
        return this.laf_1.t1(element);
      }
      t1(element) {
        if (!(!(element == null) ? isInterface(element, Runnable()) : false))
          return false;
        return this.aag((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      m1() {
        return this.laf_1.m1();
      }
      bag(elements) {
        return this.laf_1.l3(elements);
      }
      l3(elements) {
        return this.bag(elements);
      }
      q1(index) {
        return this.laf_1.q1(index);
      }
      cag(element) {
        return this.laf_1.s1(element);
      }
      s1(element) {
        if (!(!(element == null) ? isInterface(element, Runnable()) : false))
          return -1;
        return this.cag((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      p1() {
        return this.laf_1.uk_1;
      }
    }
    initMetadataForClass($, 'MessageQueue', VOID, VOID, [KtMutableList()]);
    MessageQueueClass = $;
  }
  return MessageQueueClass;
}
var WindowClearTimeoutClass;
function WindowClearTimeout() {
  if (WindowClearTimeoutClass === VOID) {
    class $ extends ClearTimeout() {
      constructor($outer, handle, $box) {
        if ($box === VOID)
          $box = {};
        $box.pag_1 = $outer;
        super(handle, $box);
      }
      ra4() {
        w3cClearTimeout(this.pag_1.rag_1, this.tag_1);
      }
    }
    initMetadataForClass($, 'WindowClearTimeout');
    WindowClearTimeoutClass = $;
  }
  return WindowClearTimeoutClass;
}
function Runnable$run$ref(p0) {
  var l = () => {
    p0.ca8();
    return Unit_instance;
  };
  l.callableName = 'run';
  return l;
}
var WindowDispatcherClass;
function WindowDispatcher() {
  if (WindowDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor(window_0) {
        super();
        this.rag_1 = window_0;
        this.sag_1 = new (WindowMessageQueue())(this.rag_1);
      }
      ra8(context, block) {
        return this.sag_1.saf(block);
      }
      ya8(timeMillis, continuation) {
        var handle = w3cSetTimeout_0(this.rag_1, () => {
          // Inline function 'kotlin.with' call
          continuation.za7(this, Unit_instance);
          return Unit_instance;
        }, delayToInt(timeMillis));
        invokeOnCancellation(continuation, new (WindowClearTimeout())(this, handle));
      }
      za8(timeMillis, block, context) {
        var handle = w3cSetTimeout_0(this.rag_1, Runnable$run$ref(block), delayToInt(timeMillis));
        return new (WindowClearTimeout())(this, handle);
      }
    }
    initMetadataForClass($, 'WindowDispatcher', VOID, VOID, [CoroutineDispatcher(), Delay()], [1]);
    WindowDispatcherClass = $;
  }
  return WindowDispatcherClass;
}
function delayToInt(timeMillis) {
  return convertToInt(coerceIn(timeMillis, 0n, 2147483647n));
}
var ClearTimeoutClass;
function ClearTimeout() {
  if (ClearTimeoutClass === VOID) {
    class $ {
      constructor(handle, $box) {
        boxApply(this, $box);
        this.tag_1 = handle;
      }
      ra4() {
        w3cClearTimeout_0(this.tag_1);
      }
      sa4(cause) {
        this.ra4();
      }
      toString() {
        return 'ClearTimeout[' + this.tag_1 + ']';
      }
    }
    initMetadataForClass($, 'ClearTimeout', VOID, VOID, [CancelHandler()]);
    ClearTimeoutClass = $;
  }
  return ClearTimeoutClass;
}
//region block: exports
export {
  NodeDispatcher_getInstance as NodeDispatcher_getInstance3tzr0otbafhkb,
  SetTimeoutDispatcher_getInstance as SetTimeoutDispatcher_getInstance3itz9uvzqmi9x,
  WindowDispatcher as WindowDispatcheram3q94j2gxvn,
};
//endregion

//# sourceMappingURL=JSDispatcher.mjs.map
